import React from 'react';
import PropTypes from 'prop-types';

import { FormattedMessage } from '../../util/reactIntl';
import { ensureCurrentUser } from '../../util/data';
import { isProviderUser } from '../../util/userHelpers';
import { PlatformTopBanner, NamedLink } from '../../components';

import css from './UnverifiedEmailBanner.module.css';

const UnverifiedEmailBanner = (props) => {
  const { rootClassName, className, currentUser } = props;
  const user = ensureCurrentUser(currentUser);

  const { emailVerified, pendingEmail } = user.attributes || {};

  const onboardingPosition = user.attributes?.profile?.publicData?.onboardingPosition;
  const isOnboarding = isProviderUser(user) && !!onboardingPosition;

  const shouldShowBanner =
    user.id &&
    !isOnboarding &&
    (!emailVerified || pendingEmail);

  if (!shouldShowBanner) {
    return null;
  }

  const hasPendingEmail = !!pendingEmail;

  return (
    <PlatformTopBanner rootClassName={rootClassName} className={className}>
      {hasPendingEmail ? (
        <FormattedMessage
          id="UnverifiedEmailBanner.pendingEmailMessage"
          values={{ email: pendingEmail }}
        />
      ) : (
        <FormattedMessage id="UnverifiedEmailBanner.unverifiedMessage" />
      )}
      {' '}
      <NamedLink name="ContactDetailsPage" className={css.link}>
        <FormattedMessage id="UnverifiedEmailBanner.linkText" />
      </NamedLink>
    </PlatformTopBanner>
  );
};

UnverifiedEmailBanner.defaultProps = {
  rootClassName: null,
  className: null,
  currentUser: null,
};

UnverifiedEmailBanner.propTypes = {
  rootClassName: PropTypes.string,
  className: PropTypes.string,
  currentUser: PropTypes.object,
};

export default UnverifiedEmailBanner;
